module.exports = __webpack_public_path__ + "static/media/calculator.fcff9ecc.svg";